import React, { useState, useEffect } from "react";
import { CustomModal } from "../../../../revampComponents/Atom/Modals";
import NoteBox from "../../../../revampComponents/Atom/NoteBox/NoteBox";

const CLONE_OPTIONS = [
    "Organiser Details",
    "Team Members",
    "Bank Details",
    "Tax & Charges",
    "Payment Methods",
    "Payment Gateways",
    "Branding Settings",
];

const CloneEventProfileModal = ({ show, onClose, onClone }) => {
    const [selectedOptions, setSelectedOptions] = useState(CLONE_OPTIONS);
    const allSelected = selectedOptions.length === CLONE_OPTIONS.length;

    const handleToggleOption = (option) => {
        if (selectedOptions.includes(option)) {
            setSelectedOptions(selectedOptions.filter((item) => item !== option));
        } else {
            setSelectedOptions([...selectedOptions, option]);
        }
    };

    const handleSelectAll = () => {
        setSelectedOptions(allSelected ? [] : [...CLONE_OPTIONS]);
    };

    // Optional: Send selected options on clone
    const handleClone = () => {
        onClone(selectedOptions); // send selectedOptions to parent
    };

    return (
        <CustomModal
            openModal={show}
            setOpenModal={onClose}
            width="30%"
            onOkay={handleClone}
            onClose={onClose}
            onCancel={onClose}
            saveBtnContent="Clone Profile"
            cancelBtnContent="Cancel"
            justifyContentForButtons="end"
            content={
                <div>
                    <div className="modal-header-clone">
                        <span>Clone Event Profile</span>
                    </div>

                    <div className="modal-subtitle">
                        Do you want to clone the following profile settings?
                    </div>

                    {/* Select All */}
                    <label className="clone-checkbox">
                        <input
                            type="checkbox"
                            id="selectAllForms"
                            className="is-checkradio pr-4 mb-1"
                            checked={allSelected}
                            onChange={handleSelectAll}
                            style={{ margin: "0px 10px 0px 0px" }}
                        />
                        <span>Select All</span>
                    </label>

                    {/* Options Grid */}
                    <div className="clone-options-grid">
                        {[0, 1].map((colIndex) => (
                            <div key={colIndex}>
                                {CLONE_OPTIONS.filter((_, i) => i % 2 === colIndex).map(
                                    (option) => (
                                        <label className="clone-checkbox" key={option}>
                                            <input
                                                type="checkbox"
                                                checked={selectedOptions.includes(option)}
                                                onChange={() => handleToggleOption(option)}
                                            />
                                            <span>{option}</span>
                                        </label>
                                    )
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Note */}
                    <NoteBox>
                        This action will clone only the settings under the Event Profile and not the associated events.
                    </NoteBox>

                    {/* Inline Styles */}
                    <style>{`
            .modal-header-clone {
              font-size: 18px;
              font-weight: 600;
              margin-bottom: 12px;
            }
            .modal-subtitle {
              font-size: 16px;
              margin-bottom: 16px;
              font-weight: 400;
            
            }
            .clone-options-grid {
              display: flex;
              gap: 48px;
              margin-bottom: 24px;
            }
            .clone-options-grid > div {
              display: flex;
              flex-direction: column;
              gap: 8px;
            }
            .clone-checkbox {
              display: flex;
              align-items: center;
              font-size: 15px;
              font-weight: 400;
              gap: 10px;
            }
            .clone-checkbox input[type="checkbox"] {
              width: 22px;
              height: 22px;
              margin-right: 6px;
              border-radius: 4px;
            }

          `}</style>
                </div>
            }
        />
    );
};

export default CloneEventProfileModal;
